import { ConditionViewerItem } from '@customerio/pluma-components/react';
import type { DeviceNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FieldOperatorValue } from '../condition-parts';

type DeviceConditionProps = { node: DeviceNode };

export function DeviceCondition({ node }: DeviceConditionProps) {
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      <FieldOperatorValue field={node.field} operator={node.operator} value={node.value} value2={node.value2} />
    </ConditionViewerItem>
  );
}
